import { AxisBottom } from '@visx/axis';
import type { D3Scale } from '@visx/scale';
import type { ScaleTime } from 'd3-scale';

interface PriceChartAxisProps {
  top: number;
  width: number;
  xScale: ScaleTime<number, number>;
  numTicks: number;
}

const PriceChartAxis = (props: PriceChartAxisProps) => {
  return (
    <g pointerEvents="none">
      <AxisBottom
        top={props.top}
        scale={props.xScale as D3Scale<number, number>}
        numTicks={props.numTicks}
      >
        {({ ticks }) => {
          return (
            <g>
              {/* <rect
                width={axisToPoint.x}
                height="1"
                y="0"
                fill="var(--chart-axis-line)"
              /> */}
              {/* <line
                x1={0}
                y1={0}
                x2={axisToPoint.x}
                y2={0}
                stroke="var(--chart-axis-line)"
                strokeDasharray="1 3"
              /> */}
              {ticks.map((n, i) => {
                return (
                  <g
                    key={`price-chart-axis-${i}-${n.formattedValue}`}
                    transform={`translate(${n.to.x}, 0)`}
                  >
                    {/* Tick */}
                    {/* <rect fill="var(--chart-axis-line)" width="1" height="6" /> */}
                    {/* Labels */}
                    <text
                      y="15"
                      fontSize="12"
                      textAnchor="middle"
                      fill="var(--chart-axis-text)"
                    >
                      {n.formattedValue}
                    </text>
                  </g>
                );
              })}
            </g>
          );
        }}
      </AxisBottom>
    </g>
  );
};

export default PriceChartAxis;
